import { BaseModel } from './basemodel';
import { DataConnectionEndpoint } from './dataConnectionEndpoint';

export enum DataConnectionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum DataConnectionType {
  CSVDataConnection = 'CSVDataConnection',
  WeclappDataConnection = 'WeclappDataConnection',
  HttpDataConnection = 'HttpDataConnection',
  SortingDataConnection = 'SortingDataConnection',
}

export interface DataConnection extends BaseModel {
  name: string;

  identifier: string;

  description: string;

  dataConnectionHandler: DataConnectionType;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  configuration: any;

  status: DataConnectionStatus;

  endpoints: DataConnectionEndpoint[];
}
